import React from 'react';
import { PageTracker } from '../../components/PageTracker.tsx';

export default function Tickets() {
  return (
    <div className="p-8 bg-red-500 rounded-lg shadow-lg">
      <PageTracker pageTitle="Tickets" category="tools" />
      <h1 className="text-2xl text-center font-semibold text-white mb-4">Jira</h1>
      <p className="text-gray-600">Tickets will be displayed here after integration.</p>
    </div>
  );
}